import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { getIsUserAdmin } from '@features/auth/state/selectors';
import { IAppState } from '@shared/models';
import { AppRoutesEnum } from '@shared/enums';

@Injectable({
  providedIn: 'root',
})
export class AdminUserGuard {
  constructor(private store$: Store<IAppState>, private router: Router) {}

  public canActivate(): Observable<boolean> {
    return this.store$.pipe(select(getIsUserAdmin)).pipe(
      take(1),
      map((isAdmin) => {
        if (!isAdmin) {
          this.router.navigate([AppRoutesEnum.DEFAULT]);
          return false;
        }

        return true;
      })
    );
  }
}

export const canActivateAdminUser: CanActivateFn = () => inject(AdminUserGuard).canActivate();
